// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__35wwc","content":"RecentSearches_content__3rWgg"};